<template>
  <div class="distribution">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.distribution.nextPage') }}>{{
              $t('setAccount.distribution.distributionLegalEntity')
            }}
          </div>
        </template>
        <div class="collapse-content">
          <el-steps :active="1" align-center>
            <el-step
              :title="$t('setAccount.distribution.essentialInformation')"
              icon="el-icon-success"
            ></el-step>
            <el-step
              :title="$t('setAccount.distribution.distributionLegalEntity')"
              icon="el-icon-time"
            ></el-step>
            <el-step
              :title="$t('setAccount.distribution.confirmledgerInformation')"
              icon="el-icon-place"
            ></el-step>
          </el-steps>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ $t('setAccount.viewAccount.corporateInformation') }}
          </div>
        </template>
        <div class="collapse-content">
          <div class="creatCalendar">
            <el-button
              type="primary"
              icon="el-icon-plus"
              class="creatButton"
              @click="insertEvent(-1)"
              >{{ $t('setAccount.viewAccount.newLegalEntity') }}</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-delete"
              class="deteButton"
              @click="handleDelete('distributionTable')"
              >{{ $t('setAccount.viewAccount.detelLegalEntity') }}</el-button
            >
            <vxe-table
              border
              :auto-resize="true"
              show-overflow
              size="mini"
              ref="distributionTable"
              :data="distriButionData"
              :edit-rules="distriButionvalidRules"
              :valid-config="{ autoPos: true, message: 'inline' }"
              :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
            >
              <vxe-table-column type="checkbox" width="80"></vxe-table-column>
              <vxe-table-column
                type="index"
                :title="$t('currenciesAndCalendar.queryCurrencies.index')"
                width="80"
              ></vxe-table-column>
              <vxe-table-column
                field="legalEntityCode"
                :title="$t('setAccount.accountList.legalEntityName')"
                min-width="140"
                :edit-render="{
                  name: 'input',
                  defaultValue: '',
                }"
              >
                <template v-slot:edit="scope">
                  <el-select
                    v-model="scope.row.legalEntityCode"
                    @change="changeLegalEntity(scope.row)"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="item in accountChartCodeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
                <template v-slot="scope">
                  {{ scope.row.legalEntityName }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="legalEntityCode"
                :title="$t('setAccount.viewAccount.legalEntityCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">{{
                  distriButionData[scope.rowIndex].legalEntityCode
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="legalEntityRegionName"
                :title="$t('setAccount.viewAccount.legalEntityRegionCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">
                  {{ distriButionData[scope.rowIndex].legalEntityRegionName }}</template
                >
              </vxe-table-column>
              <vxe-table-column
                field="registrationCode"
                :title="$t('setAccount.viewAccount.registrationCode')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">{{
                  distriButionData[scope.rowIndex].registrationCode
                }}</template>
              </vxe-table-column>
              <vxe-table-column
                field="legalAddress"
                :title="$t('setAccount.viewAccount.legalAddress')"
                min-width="140"
                :edit-render="{ type: 'default' }"
              >
                <template v-slot:edit="scope">{{
                  distriButionData[scope.rowIndex].legalAddress
                }}</template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/systemManage/accountManage';
  export default {
    name: 'distribution',
    components: {},
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        //获取国籍
        nationalityList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'person_national').dictList;
          }
        },
      }),
    },
    data() {
      return {
        activeNames: ['1', '2'],
        distriButionvalidRules: {
          legalEntityCode: [
            {
              required: true,
              message: this.$t('setAccount.viewAccount.changeLegalEntityCode'),
            },
          ],
        },
        distriButionData: [],
        accountChartCodeList: [], //法人主体
      };
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      //增加
      insertEvent(row) {
        let distributionTable = this.$refs.distributionTable;
        let record = {};
        distributionTable.insertAt(record, row).then(({ row }) => {
          distributionTable.setActiveRow(row);
        });
        this.distriButionData = this.$refs.distributionTable.getTableData().fullData;
      },
      // 删除
      handleDelete(tableTpye) {
        const selectedList = this.$refs[tableTpye].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('personnel.table.chockedLows'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs[tableTpye].removeSelecteds();
            this.$refs.distributionTable.updateStatus({});
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('personnel.table.deletSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('personnel.table.deletFalse'),
            });
          });
      },
      //校验
      fullValidEvent() {
        this.flag = true;
        let formList = ['distributionTable'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              valid ? resolve() : reject();
            });
          });
          resultArr.push(result);
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.distriButionData = this.$refs.distributionTable.getTableData().fullData;
        if (this.distriButionData.length <= 0) {
          this.flag = false;
        }
        let childList = {
          distriButionData: this.distriButionData,
        };
        return Promise.all(resultArr)
          .then(() => {
            if (!this.flag) {
              this.$message({
                showClose: true,
                message: this.$t('personnel.table.tableTitle'),
                type: 'error',
              });
            } else {
              return childList;
            }
          })
          .catch(() => {});
      },
      changeLegalEntity(row) {
        this.accountChartCodeList.map((item) => {
          if (item.legalEntityCode == row.legalEntityCode) {
            row.legalEntityCode = item.legalEntityCode;
            row.legalEntityRegionCode = item.legalEntityRegionCode;
            row.registrationCode = item.registrationCode;
            row.legalAddress = item.legalAddress;
          }
        });
        let accountChartCodeItem = this.accountChartCodeList.find(
          (item) => item.legalEntityCode === row.legalEntityCode
        );
        if (accountChartCodeItem) {
          row.legalEntityName = accountChartCodeItem.label;
        } else {
          row.legalEntityName = null;
        }
        this.nationalityList.map((item) => {
          if (row.legalEntityRegionCode == item.areaCode) {
            row.legalEntityRegionName = item.label;
          }
        });
        let flag = false;
        let LegalList = this.$parent.LegalList;
        LegalList.forEach((r) => {
          if (row.legalEntityCode == r.legalEntityCode) {
            flag = true;
          }
        });
        if (flag) {
          this.$message({
            showClose: true,
            message: this.$t('setAccount.accountList.accountChartError'),
            type: 'error',
          });
        }
      },
      //获取公司
      async getCompany() {
        const selectStatus = await this.$axios.get(
          API.LISTDATA_SERECHCOMPANY + `/${this.userInfo.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.accountChartCodeList = selectStatus.data.data;
          this.accountChartCodeList.forEach((item) => {
            item.legalEntityRegionCode = item.companyNational;
            item.legalAddress = item.companyAddress;
            item.legalEntityCode = item.value;
            item.legalEntityName = item.label;
            item.registrationCode = item.creditCode;
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .distribution .creatButton {
    background-color: rgb(98, 153, 254) !important;
    border: 1px solid rgb(98, 153, 254) !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .distribution .deteButton {
    background-color: #fe8783 !important;
    border: 1px solid #fe8783 !important;
    min-width: 80px;
    border-radius: 2px !important;
    margin-bottom: 10px;
  }
  .distribution .collapse-content {
    padding-top: 10px;
  }
  .distribution .el-select {
    display: inline-block;
    position: relative;
    width: 100% !important;
  }
</style>
